// 符號物件池 — 對應 Unity SymbolPool / GameObjectPool。避免頻繁建立/銷毀。
import { SymbolView } from '../game/view/SymbolView'

export class SymbolPool {
  private readonly free: SymbolView[] = []

  obtain(): SymbolView {
    return this.free.pop() ?? new SymbolView()
  }

  release(symbol: SymbolView): void {
    symbol.setHighlight(false)
    symbol.setDimmed(false)
    this.free.push(symbol)
  }
}
